import React, { useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, TextField
} from '@material-ui/core'

import { Alert, } from '@material-ui/lab';
import SelectCompany from '../../components/SelectCompany';
import CompanyApi from '../../services/company.service';
import SettingsApi from '../../services/settings.service';

export default function FeatureSettings() {
    const [entity, setEntity] = useState('onlineWebBooking');
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);

    const apiservices = new CompanyApi();
    const settingServices = new SettingsApi();
    const [obDefaultPayload, setOBDefaultPayload] = useState(
`{"companyId": 3,
"officeTiming": {
"sunday": {
    "open": false,
    "start": "08:00",
    "end": "12:00",
    "duration": "01:30"
},
"monday": {
    "open": true,
    "start": "08:00",
    "end": "16:00",
    "duration": "02:00"
},
"tuesday": {
    "open": true,
    "start": "08:00",
    "end": "16:00",
    "duration": "02:00"
},
"wednesday": {
    "open": true,
    "start": "08:00",
    "end": "16:00",
    "duration": "02:00"
},
"thursday": {
    "open": true,
    "start": "08:00",
    "end": "16:00",
    "duration": "02:00"
},
"friday": {
    "open": true,
    "start": "08:00",
    "end": "16:00",
    "duration": "02:00"
},
"saturday": {
    "open": false,
    "start": "08:00",
    "end": "16:00",
    "duration": "02:00"
}
},
"buffer": "00:00",
"dayBuffer": "2",
"sendToEmails": ["developer@smartserv.io"],
"bookingLimit": 3,
"bookingDaysLimit": 30
}`
    );

    const handleChange = async (e: any) => {
        switch (e.target.value) {
            case 'OB':
                setEntity('onlineWebBooking');
                break;
        }
    }
    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Deletion Cancelled.`);
    }
    const onClose = () => {
        setErrorDialog(false)
    }
    const getOBPayload = (e: any) => {
        setOBDefaultPayload(e.target.value);
    }

    const update = async () => {
        try {
            let companyId = localStorage.getItem("selectedCompanyId");
            let obSetting = { isOnlineWebBookingEnabled: true, companyId };
            let obPayload = { ...JSON.parse(obDefaultPayload), companyId };
            let webBookingRes = await apiservices.onlineWebBooking(obPayload);
            let obSettingsRes = await settingServices.updateSettings( 'generic', obSetting );
            let obStatuses = [
              {
                name: "Open",
                description: "",
                companyId: companyId,
                statusUniqueId: "Open",
              },
              {
                name: "Converted",
                description: "",
                companyId: companyId,
                statusUniqueId: "Converted",
              },
              {
                name: "Declined",
                description: "",
                companyId: companyId,
                statusUniqueId: "Declined",
              },
            ];
            let obStatusRes = await apiservices.insertOBStatus(obStatuses);
            let obSources = [
                {
                    name: 'Web',
                    displayName:  'Web',
                    description: '',
                    companyId: companyId
                },
                {
                    name: 'Telephonic',
                    displayName:  'Telephonic',
                    description: '',
                    companyId: companyId
                },
                {
                    name: 'Customer Referral',
                    displayName:  'Customer Referral',
                    description: '',
                    companyId: companyId
                },
                {
                    name: 'Campaign',
                    displayName:  'Campaign',
                    description: '',
                    companyId: companyId
                },
                {
                    name: 'Other',
                    displayName:  'Other',
                    description: '',
                    companyId: companyId
                }
            ]
            let obSourceRes = await apiservices.insertOBSource(obSources);
            if (webBookingRes && obSettingsRes && obStatusRes && obSourceRes) {
                setDialog(false);
                setSnackBar("success");
                setPageResponse("Enabled Successfully.");
            }
            else{
                setDialog(false);
                setSnackBar("error");
                setPageResponse(`Process Failed`);
            }
        } catch (error) {
            setDialog(false);
            setSnackBar("error");
            setPageResponse(`Process Failed, error: ${error}`);
            return;
        }
    };

    return (
        <>
            <SRCards />
            <Container>
                <SelectCompany />
                <br /><br />
                <Button className='qbsync_body'
                    onClick={update}
                    style={{ margin: 10 }}
                    variant='outlined'> Enable </Button>
                <br></br><br></br>
                <FormControl fullWidth className='rediscache_body'>
                    <InputLabel id="demo-simple-select-label">Feature</InputLabel>
                    <Select
                        onChange={handleChange}
                    >
                        <MenuItem selected value={'OB'}>Online Web Booking</MenuItem>
                    </Select>
                </FormControl>
                <br /> <br />
                {entity === 'onlineWebBooking' &&
                    <>
                        <TextField
                            fullWidth
                            id="outlined-multiline-static"
                            label="Payload"
                            value={obDefaultPayload}
                            multiline
                            rows={20}
                            variant="outlined"
                            onChange={getOBPayload} />
                    </>
                }
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    //deleteEntity()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please provide the details before proceeding.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}